// The attendance screen posts four groups of student marks: one per shift
// (`first`, `second`) plus a side channel per shift for early pick-ups
// (`first_alt`, `second_alt`). Presence is the default and is stripped before
// saving, so a report describes the exceptions of a day, not the whole class.

// Mirrors biz.TOPIC_TYPES (absence / late / justified) plus `late2`, a second
// lateness degree that only the attendance screen produces.
const ABSENCE = 'absence'
const LATE = 'late'
const LATE_2 = 'late2'
const JUSTIFIED = 'justified'
const EARLY_PICK_UP = 'early_pick_up'

export interface StudentMarks {
  [studentId: string]: string
}

// keyed by form group: first, first_alt, second, second_alt
export interface AttendanceReport {
  [group: string]: StudentMarks
}

export interface AttendanceReportSummary {
  // total non-presence marks saved. One student can hold more than one (a late
  // arrival in `first` and an early pick-up in `first_alt`), so this is a mark
  // count, not a count of students
  mark_count: number
  absence_count: number
  late_count: number
  justified_count: number
  early_pick_up_count: number
}

export function summarizeReport (report?: AttendanceReport): AttendanceReportSummary {
  const summary: AttendanceReportSummary = {
    mark_count: 0,
    absence_count: 0,
    late_count: 0,
    justified_count: 0,
    early_pick_up_count: 0
  }

  if (!report) {
    return summary
  }

  Object.keys(report).forEach(group => {
    const marks = report[group] || {}

    Object.keys(marks).forEach(studentId => {
      const mark = marks[studentId]
      summary.mark_count++

      if (mark === ABSENCE) {
        summary.absence_count++
      } else if (mark === LATE || mark === LATE_2) {
        // a `late2` is a graver late arrival, still a late arrival
        summary.late_count++
      } else if (mark === JUSTIFIED) {
        summary.justified_count++
      } else if (mark === EARLY_PICK_UP) {
        summary.early_pick_up_count++
      }
    })
  })

  return summary
}
